import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { AnonymousSearchConfig } from '../../models/anonymous-search-config.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
    selector: 'app-anonymous-search',
    templateUrl: './anonymous-search.component.html',
    styleUrls: ['./anonymous-search.component.scss']
})
export class AnonymousSearchComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { defId: "string", searchString: "string?" };
    defId: string;
    searchString: string;

    config: AnonymousSearchConfig;
    form: FrontendFormDefinition;

    async initParams(): Promise<boolean> {
        this.config = await RestEndpoint.main().query({defId: this.defId}).run("api/doc/def/anonymoussearchdef").get(AnonymousSearchConfig);
        if (Utils.isNoe(this.searchString)) {
            this.form = new FrontendFormDefinition(this.config.formFields);
        }
        else {
            await this.search(this.searchString);
        }
        return true;
    }

    async search(searchString?: string): Promise<void> {
        if (searchString == null) {
            if (!this.app.validateForm(this.form)) {
                return;
            }

            searchString = Utils.arrayItemsToString(this.form.fields, ";", f => f.id + "=" + (f.value instanceof Date ? Utils.dateFormat(f.value, "dd.mm.yyyy") : f.value));
        }

        let result = await this.app.genericDataHandler(async () => RestEndpoint.main().query({defId: this.defId, searchString}).run("api/doc/def/anonymoussearch").getText(), "Fehler bei der Suche", "toast");
        if (result.ok && !Utils.isNoe(result.value)) {
            await this.app.navigateTo(["/enaio-documents", "definition", "as", this.defId, result.value]);
        }
    }

}
